export enum SELLER_DOMAIN {
  VALUE = 'value',
  BY_TENANT_ID = 'byTenantId',
  SELLER_IDS = 'sellerIds',
  TENANT_IDS = 'tenantIds',
}

export const SELLER_DOMAIN_KEY = 'sellers';
